export default __webpack_public_path__ + "static/assets/med_x_spoon_mask.5b93e8c2.png";